const STORAGE_KEY = 'rdx-guest-invitation';
const RECOVERY_MS = 30 * 60 * 1000;
interface Recovery {
  path: string;
  key: string;
  expiresAt: number;
}
let credential: Recovery | null = null;

function usable(value: Recovery | null, path: string): value is Recovery {
  return (
    !!value &&
    value.path === path &&
    typeof value.key === 'string' &&
    value.key.length > 0 &&
    value.key.length <= 512 &&
    Number.isFinite(value.expiresAt) &&
    value.expiresAt > Date.now() &&
    value.expiresAt <= Date.now() + RECOVERY_MS
  );
}

/** Remove bearer credentials before routing/telemetry. Recovery is tab-scoped, never localStorage. */
export function captureInvitationKey(): string {
  if (typeof window === 'undefined' || !/^\/v\/[^/]+\/?$/.test(window.location.pathname)) return '';
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.hash.slice(1));
  const key = params.get('token') ?? params.get('key');
  if (key !== null) {
    forgetInvitationKey();
    credential =
      key.length > 0 && key.length <= 512
        ? { path, key, expiresAt: Date.now() + RECOVERY_MS }
        : null;
    try {
      if (credential) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(credential));
    } catch {
      /* Storage can be blocked; the current page still works in memory. */
    }
    params.delete('token');
    params.delete('key');
    window.history.replaceState(
      window.history.state,
      '',
      path + window.location.search + (params.size ? '#' + params.toString() : ''),
    );
  }
  if (!usable(credential, path)) {
    credential = null;
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? 'null') as Recovery | null;
      if (usable(stored, path)) credential = stored;
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      /* Invalid or unavailable storage grants no access. */
    }
  }
  return credential?.key ?? '';
}

/** Called only after the server confirms the invitation is unavailable. */
export function forgetInvitationKey(): void {
  credential = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* Storage is optional. */
  }
}
